// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:712px){.pricelist-card[data-v-a5bf5474]:nth-child(odd):last-child{grid-column:1/-1;max-width:calc(100dvw/2 - 2.25rem);width:100%;justify-self:center}}@media (min-width:1072px){.pricelist-card[data-v-a5bf5474]{grid-column:span 1!important;max-width:unset!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
